/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2021, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

/**
 * @module bulb-progress/bulb-transcoding/bulbtranscoding
 */

import { Plugin } from 'ckeditor5';
import BulbTranscodingProgress from './bulbtranscodingprogress';
import BulbTranscodingEditing from './bulbtranscodingediting';

export default class BulbTranscoding extends Plugin {

  /**
   * @inheritDoc
   */
  public static get pluginName() {
    return 'BulbTranscoding' as const;
  }

  /**
   * @inheritDoc
   */
  public static get requires() {
    return [BulbTranscodingEditing, BulbTranscodingProgress] as const;
  }
}
